import React from "react";

interface IPopularDestinations {
  image: string;
  name: string;
}

const PopularDestinations: React.FC = () => {
  const popularDestinationsData: IPopularDestinations[] = [
    {
      image: "/tourism/destination/destination-1.png",
      name: "Varanasi & Kashi",
    },
    {
      image: "/tourism/destination/destination-2.png",
      name: "Ujjain Mahakal",
    },
    {
      image: "/tourism/destination/destination-3.png",
      name: "Amritsar",
    },
    {
      image: "/tourism/destination/destination-4.png",
      name: "Anandpur Sahib",
    },
    {
      image: "/tourism/destination/destination-5.png",
      name: "Chamkaur Sahib",
    },
    {
      image: "/tourism/destination/destination-6.png",
      name: " Khatkar Kalan",
    },
  ];

  return (
    <div className="flex flex-col gap-4 lg:gap-7">
      <h3 className="text-[#050B20] text-2xl sm:text-4xl lg:text-5xl xl:text-6xl">
        Popular Destinations We Cover
      </h3>
      <div className=" border-[3px] border-[#182152] w-32 sm:w-44 md:w-72 lg:w-96" />
      <p className="max-w-[34rem] sm:text-lg lg:text-xl text-[#5B5F62]">
        Our Tour Guide App is not just a tool; it's a transformative experience
        for diverse settings. Here's how it's redefining tourism and cultural
        exploration:
      </p>
      <div className="grid lg:pt-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-5 xl:gap-10">
        {popularDestinationsData.map((data) => {
          return (
            <div
              key={data.name}
              className="text-[#2D3134] flex flex-col justify-center items-center font-bold lg:text-lg xl:text-2xl"
            >
              <div className="rounded-full ">
                <img
                  src={data.image}
                  alt={data.name}
                  className="rounded-full"
                />
              </div>
              <p className="text-center pt-3 flex-1 max-w-48">{data.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PopularDestinations;
